
import { AppSettings } from './../shared/app-settings';
import { Injectable } from '@angular/core';
import { HttpService } from '../shared/http.service';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { IRishum } from './rishum'
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';

import { IPeilut } from './peilut.interface'
import { IUserDetails } from './user-details'
import {IUserPeilutData} from './userPeilutData'
import { ConfigService } from 'app/shared/config.service';
import { IPeiluyot } from 'app/peiluyots/peiluyot.interface';


@Injectable()
export class PeilutService {

    private _peilutUrl;
    private _userUrl;
    apiUrl : string = "";
    constructor(private _http: HttpService, public router: Router,private _configService:ConfigService)
     {
         this.apiUrl = _configService.getConfigPropertyByKey("apiUrl");
         this._peilutUrl = `${this.apiUrl}/api/Peilut`;
         this._userUrl = `${this.apiUrl}/api/User`;
     }

    getPeiluyot(): Observable<IPeiluyot[]> {
        return this._http.get(this._peilutUrl)
            .map((response: Response) => <IPeiluyot[]>response.json())
            .catch(this.handleError);
    }

    saveRishum(rishum: IRishum): Observable<IRishum> {      
        return this._http.post(this._peilutUrl, JSON.stringify(rishum))
            .map(res => res.json())
            .catch(this.handleError)

    }

    getUserDetails(): Observable<IUserPeilutData> {
        return this._http.get(this._userUrl)
            .map((response: Response) => <IUserPeilutData>response.json());
           //.catch(this.handleError);

    }

    getBenZugDetails(ms_zehut: number): Observable<IUserDetails> {
       // let params: URLSearchParams = new URLSearchParams();
      //  params.set('ms_zehut', ms_zehut.toString());
        return this._http.get(`${this.apiUrl}/api/User/GetUserDetails` + `?ms_zehut=${ms_zehut}`)
            .map((response: Response) => <IUserDetails>response.json())
            .catch(this.handleError);

    }

    private handleError(error: Response | any) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        let errMsg: string;
        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);

            errMsg = `${error.status} - ${error.statusText || ''} ${err}`;

        } else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
}